import { withVersions } from "v2/hocs/withVersions";
import RowDividerUIV1 from "./RowDivider/v1";

const Divider = {
  Row: withVersions({
    v1: RowDividerUIV1,
    v2: RowDividerUIV1,
  }),
  // TODO: Add ColDivider
  // Col: withVersions({
  //   v1: ColDividerUIV1,
  //   v2: ColDividerUIV1,
  // }),
};

export default Divider;
